export const DEFAULT_LANGUAGE = "en";
export const SYS_INTERVAL = 20000;

export const LS_ITEMS = {
  appData: "appData",
  factoryData: "factoryData",
  userData: "userData",
};

export const logoUrl = "/assets/icons/logo.png";
export const SYSTEM_ERROR = "System error. Please try again later!";

export const STATUS_COLORS = [
  "#ffec00",
  "#549afc",
  "#c000db",
  "#9898db",
  "#B0E0E6",
  "#6aa786",
  "#c0a0c0",
  "#808080",
  "#ff0000",
  "#46c392",
  "#000000",
];

export const PROCESS_TYPES = [
  "None",
  "Time Logger",
  "Cleaning Station",
  "Blast Station",
  "Paint Station",
  "Assembly Station 137",
  "Assembly Station 136",
  "Assembly Station 3",
  "Quality",
];

export const gdtFomulars = [
  { id: "72", name: "Square Inches" },
  { id: "73", name: "Total Goods" },
];
